<template>
    <v-menu offset-y content-class="white" max-height="calc(100% - 104px)" v-model="showSites" nudge-top="-4">
        <template v-slot:activator="{ on, attrs }">
            <div
                v-bind = "attrs"
                v-on   = "on"
                class  = "v-flex"
            >
                <div
                    v-for  = "(site, idx) in maxsites"
                    :key   = "site.id"
                    class  = "site-box"
                    :class = "color"
                    :style = "boxsize"
                >
                    <div v-if="idx === index" class="site-indicator"></div>
                </div>
                <div v-if="sites && sites.length > 5">
                    <i class="fas fa-ellipsis-h " :class="index >= maxsites.length ? 'orange--text' : 'white--text'"></i>
                </div>
            </div>
        </template>

        <div class="pa-2 pr-1 pl-2" style="border-radius: 5px; overflow-y: scroll; position: relative">
            <a
                v-for  = "(unit, index) in sites"
                :key   = "unit.id"
                @click = "onSelect(unit)"
            >
                <v-hover
                    v-slot="{ hover }"
                >
                    <div>
                        <slot name="header" v-bind:data="{ unit: unit, compact: false }" />
                        <c-site-card-dense
                            :site  = "unit"
                            style  = "width: 300px;"
                            :class = "index < sites.length-1 ? 'mb-2 ' + background(unit) : background(unit)"
                            :style = "hover ? 'background-color: #f0f0f0' : ''"
                        />
                    </div>
                </v-hover>
            </a>
        </div>
    </v-menu>
</template>

<script>

import Inc            from "@/modules/inc/service/Inc";
import Core           from "@/modules/core/service/Core";
import CSiteCardDense from "@/modules/msd/unit/components/controlls/CSiteCardDense.vue";

export default {
    name: "CSiteIconList",

    components: {
        CSiteCardDense,
    },

    props: {
        sites: {
            required: true,
            type    : Array
        },

        incidentId: {

        },

        color: {
            required: false,
            default: function () {
                return "white";
            }
        },

        size: {
            required: false,
            default: function () {
                return 18;
            }
        },
    },

    data: () => ({
        showSites    : false,
        showSelection: false,
    }),

    computed: {
        customer () {
            if (!this.sites || this.sites.length === 0) {
                return null;
            }

            return this.sites[0].customer;
        },

        maxsites () {
            if (!this.sites) {
                return [];
            }

            if (this.sites.length > 5) {
                return this.sites.slice(0, 5);
            }

            return this.sites;
        },

        boxsize () {
            return "width: " + this.size + "px;" + "height: " + this.size + "px;";
        },

        selected () {
            return this.$store.getters.context.site;
        },

        index () {
            return  this.sites.findIndex (u => u.id === this.selected);
        }
    },

    methods: {
        onSelect (site) {
            if (this.incidentId) {
                Inc.goto(this, this.incidentId, site.id);
            } else {
                Core.message.warning(this, "Die Meldung ist noch keinem Ereignis zugeordnet.")
            }
        },

        background (site) {
            return this.selected === site.id ? 'primary-border-thick ' : '';
        },
    }
}
</script>

<style scoped>

.site-box {
    margin-right: 3px;
    border-radius: 2px;
    margin-top: 2px;
}

.site-indicator {
    background-color: orange;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin-left: 3px;
    margin-top: 3px;
}

</style>